import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom'
import Time from 'react-time-format'
import NProgress from 'nprogress'

import Selector from '../Selector';
import PlayButton from '../PlayButton';
import ElementShortcuts from '../ElementShortcuts';
import UserOverview from './UserOverview';
import UserArtists from './UserArtists';
import UserTracks from './UserTracks';
import UserSuggestions from './UserSuggestions';
import UserScrobbles from './UserScrobbles';
import UserCharts from './UserCharts';
import UserSettings from './UserSettings';
import TagList from '../TagList';


import Train from '../../services/train.js';
import NumberUtils from '../../services/NumberUtils.js';
import Notification from '../../services/Notification.js'
import UserService from '../../services/User.js';

import '../../../css/User.css';
import '../../../css/elementPage.css';

class User extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: undefined,
      img: undefined
    }
  }

  refresh() {
    this.fetchData(this.state.userName);
  }

  fetchData(userName) { 
    NProgress.start();
    Train.fetchUser({user: userName})
    .then((user) => {
      this.setState({user, userName, img: user.img});
      NProgress.done();
    }).catch((e) => {
      Notification.show('Error loading user data', 'error');
      NProgress.done();
    });

  }

  componentDidMount() {
    this.fetchData(this.props.match.params.user);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.match.params.user !== this.state.userName) {
      this.setState({
        user: undefined,
        img: undefined
      });
      this.fetchData(newProps.match.params.user);
    }
    
  }

  uploadProfilePicture(evt) {

    let files = evt.target.files;

    if (files.length < 1)
      Notification.show('Error selecting file', 'error');
    else
    {

      var image = files[0];
      if (image.size > 2*1024*1024)
        Notification.show('Maximum size of 2mb', 'error');
      else
      {
        var reader = new FileReader();

        reader.onload = (e) => {
          this.setState({img: e.target.result});
        }

        reader.readAsDataURL(files[0]);

        var fd = new FormData();
        fd.append("file", image);

        Notification.show('Picture upload in progress', 'info');

        Train.uploadUserPicture({file: fd})
        .then((data) => {
          this.setState({img: data.path})
          Notification.show('Picture upload completed', 'success');
        })
        .catch(() => {
          Notification.show('Picture upload failed', 'error');
        });  

      }

    }

  }

  openFileForm(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.refs.fileForm.click();
  };

 render() {

    let user = this.state.user;

    if (!user) {
      return null;
    }

    let imageStyle = {
      backgroundImage: `url(${this.state.img})`
    };


    let isLoggedIn = UserService.isLoggedIn();

    let isOwnUser = isLoggedIn && UserService.getId() === user.user;

    let basePath = `/users/${user.user}`;

    let selectorElements = [];
    let initialPath = 'settings'

    if (user.artistsCount > 0) {
      selectorElements = [
        {title: 'Overview', url: `${basePath}/overview`},
        {title: 'Artists', url: `${basePath}/artists`},
        {title: 'Tracks', url: `${basePath}/tracks`}, 
        {title: 'Scrobbles', url: `${basePath}/scrobbles`},
        {title: 'Suggestions', url: `${basePath}/suggestions`},
        {title: 'Charts', url: `${basePath}/charts`}
      ];
      initialPath = 'overview';
    }

    if (isOwnUser)
      selectorElements.push({title: 'Settings', url: `${basePath}/settings`});

    return (
 
      <div className="elementPage">

        <div className="header">

          <div className="profileImage" style={imageStyle}>
            {isOwnUser && <i onClick={this.openFileForm.bind(this)} className="fontastic icon-camera clickable"></i>}
          </div>
          <form style={{height:0, width: 0}} noValidate encType="multipart/form-data">
            <input style={{visibility: 'hidden'}} ref="fileForm" onChange={this.uploadProfilePicture.bind(this)} accept="image/jpeg,image/gif,image/png" type="file" />
          </form>

          <div className="content">

            <h1>{user.username}</h1><PlayButton type={'user'} element={user}></PlayButton>

            <br/>

            <div className="stats">
              <span><b>Artists</b> {NumberUtils.abbreviation(user.artistsCount)}</span>
              <span><b>Plays</b> {NumberUtils.abbreviation(user.tracksCount)}</span>
              <span><b>Discoveries</b> {NumberUtils.abbreviation(user.discoveredArtistsCount)}</span>
              <span><b>Since</b> <Time value={user.since} format="DD/MM/YYYY"/></span>
            </div>

            <TagList tags={user.tags} selector={true}/>
            <ElementShortcuts type={'user'} element={user}/>

          </div>


        </div>

        <Selector elements={selectorElements}></Selector>

        <Switch>
          <Route path="/users/:user/overview" component={ UserOverview }></Route>
          <Route path="/users/:user/artists" component={ UserArtists }></Route>
          <Route path="/users/:user/tracks" component={ UserTracks }></Route>
          <Route path="/users/:user/suggestions" component={UserSuggestions}></Route>
          <Route path="/users/:user/scrobbles" component={UserScrobbles}></Route>
          <Route path="/users/:user/charts" component={UserCharts}></Route>
          { isOwnUser && <Route path="/users/:user/settings" component={() => <UserSettings refreshCb={this.refresh.bind(this)}/>}></Route> }
          <Route render={ () => <Redirect to={`${basePath}/${initialPath}`}/> }></Route>
        </Switch>

        
      </div>
              
    ); 

  }
}

export default User;



// WEBPACK FOOTER //
// ./src/js/components/user/User.jsx